import { EmeraldError, EmeraldErrorModal } from 'src/common/api/emerald-error';
import { popEmeraldModal } from 'src/common/emerald-modal-manager/emerald-modal-manager';
import { EmeraldDialogTypes } from 'src/common/enumerations/emerald-dialog-types';
import { IdmExitTrainingModeException } from 'src/common/helpers/error-code';
import XLRLogger from 'src/common/helpers/logger';
import { enablePayments, setPinPadTrainingMode } from 'src/devices/payment/pinpad-operations';
import { TRAINING_MODE_LOGOUT_MODAL } from 'src/menu-panel/components/training-logout-buttons/training-logout-buttons';
import { popupMessage } from 'src/messages/business-logic/popup-message';
import { store } from '../../common/redux/configure-store';
import { POSModeActions } from '../../common/redux/reducers/pos-mode-reducer';
import { getLatestTransaction } from '../../home-page/business-logic/get-latest-transanction';
import { resumeTransaction } from '../../home-page/business-logic/resume-transaction';
import { updateTouchPointConfiguration } from '../../touchpoint/business-logic/touchpoint-configuration';
import { clearPinPad } from './../../devices/payment/pinpad-operations';
import { exitTrainingMode } from './service/set-training-mode';

export const trainingModeOff = async (serverSideExitTrainingMode: boolean): Promise<void> => {
  if (serverSideExitTrainingMode) {
    try {
      await exitTrainingMode(false);
      await exitTrainingMode(true);
    } catch (err) {
      if (err instanceof EmeraldError && err.code === IdmExitTrainingModeException) {
        const message = new EmeraldErrorModal({
          type: EmeraldDialogTypes.Warning,
          subMessage: 'ExitTrainingMode_ErrorSubHeader',
        });
        return popupMessage(message);
      }
      return popupMessage(err);
    }
  }
  popEmeraldModal(TRAINING_MODE_LOGOUT_MODAL);

  store.dispatch(POSModeActions.toggleTrainingMode());
  if (store.getState().pinPad.isPinpadConfigured) {
    await clearPinPad();
    await updateTouchPointConfiguration().catch(err => {
      XLRLogger.error({
        message: `SignOffCommand failed to UpdateTouchPoint , Ex :${err.Message} `,
        source: 'training-mode-off.ts',
      });
    });
    await enablePayments();
    await setPinPadTrainingMode(store.getState().posMode.trainingMode);
  }
  if (serverSideExitTrainingMode) {
    await getLatestTransaction();
  }
  await resumeTransaction();
};
